<template>
  <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Corpo principal do S -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="
        M 25 0
        C 20 0, 16 0.5, 12.5 1.8
          9 3.1, 7 5.3, 7 7.5
          C 7 9.2, 8.1 10.4, 9.8 11.1
          11.5 11.8, 13.9 12.1, 16 12.3

          C 18.5 12.6, 20.3 13, 21.6 13.7
          22.9 14.4, 23.7 15.4, 23.7 16.7
          C 23.7 18.1, 22.7 19.2, 20.8 20
          18.9 20.8, 16.1 21.3, 13 21.3
          C 9.5 21.3, 6.8 20.7, 4.9 19.8
          3 18.9, 2 17.6, 2 16

          C 2 15.6, 2.05 15.2, 2.15 14.8
          2.25 14.4, 2.4 14.0, 2.6 13.6
          L 0 13.6
          C 0.2 14.4, 0.3 15.2, 0.3 16.1
          C 0.3 18.5, 1.6 20.4, 4 21.7
          6.4 23, 9.7 23.7, 13.5 23.7
          C 17.3 23.7, 20.6 23, 23.1 21.7
          25.6 20.4, 27 18.5, 27 16.4

          C 27 14.5, 26.1 13.1, 24.7 12.1
          23.3 11.1, 21.3 10.5, 18.9 10.2
          L 15.5 9.9
          C 13.4 9.7, 11.8 9.3, 10.7 8.8
          9.6 8.3, 9.0 7.5, 9.0 6.6
          C 9.0 5.1, 10.1 3.8, 12.0 2.9
          13.9 2.1, 16.6 1.7, 19.9 1.7
          C 22.3 1.7, 24.3 2.0, 26.0 2.5
          27.7 3.0, 29.0 3.8, 30 4.9
          L 32 3.0
          C 31.1 1.9, 29.9 1.0, 28.3 0.5
          26.7 0.1, 25.0 0, 25 0
        Z
      "
      fill="#7367F0"
    />

    <!-- Sombra interna (leve) na parte central -->
    <path
      opacity="0.06"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="
        M 10.5 8.2
        C 12.0 8.9, 13.9 9.3, 16.1 9.5
          18.7 9.8, 20.7 10.2, 22.1 10.9
          23.5 11.6, 24.3 12.6, 24.3 13.8
          C 24.3 15.1, 23.5 16.2, 22.0 17.0
          20.5 17.8, 18.3 18.2, 15.6 18.3
          C 13.0 18.4, 11.0 18.1, 9.3 17.6
          7.6 17.1, 6.4 16.3, 5.7 15.4
          6.2 14.0, 7.3 13.1, 9.0 12.4
          10.7 11.7, 12.9 11.4, 15.3 11.4
          C 14.0 11.1, 12.5 10.8, 11.3 10.3
          10.1 9.8, 9.2 9.1, 8.6 8.4
          9.1 8.2, 9.8 8.1, 10.5 8.2
        Z
      "
      fill="#161616"
    />
  </svg>
</template>
<script>
export default {
  name: 'Logo',
}
</script>
